<template>
    <v-container style="background:white" grid-list-xs text-xs-center >
        <v-layout justify-center> 
            <h2 class="font-weight-bold" >{{language === 'English' ? 'Sign up':'Crear cuenta'}}</h2>
        </v-layout>
       <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate()">
            <v-layout row >
                <v-flex>
                    <v-text-field  :label="language === 'English' ? 'Names and Surnames':'Nombres y Apellidos'" v-model="users.fullname" :rules="[rules.required]" required>
                    </v-text-field>
                    <!--v-text-field  :label="language === 'English' ? 'Surnames':'Apellidos'" v-model="users.apellidos" :rules="[rules.required]"  required>
                    </v-text-field-->
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="M" v-model="users.gender">
                        <label class="form-check-label" for="inlineRadio1">{{language === 'English' ? 'Male':'Masculino'}}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="F" v-model="users.gender">
                        <label class="form-check-label" for="inlineRadio2">{{language === 'English' ? 'Female':'Femenino'}}</label>
                    </div>                                    
                    <!--v-radio-group style="justify-content: center" :rules="[rules.required]"  v-model="users.gender" row>
                        <v-radio label="Hombre" required value="M" name="gender" ></v-radio>
                        <v-radio label="Mujer" required value="F" name="gender"></v-radio>                                            
                    </v-radio-group-->  
                        <!--v-layout>
                            <v-flex > 
                                <v-text-field :label="language === 'English' ? 'Telephone or cell phone number':'Numero de teléfono o celular'" v-model="users.phone" :rules="[rules.required]" required type="number">
                                </v-text-field>
                            </v-flex>
                        </v-layout-->
                        <v-layout justify-center style="margin-top:10px">
                            <label @click="addocupation" style="cursor:pointer">{{language === 'English' ? 'Add more occupations':'Agregar mas ocupaciones'}}</label>
                        </v-layout>
                        <div class="scrollmenucompany" style="overflow-y: scroll;height:200px;">
                            <v-layout v-for="(ocupation,index) in users.ocupation" :key="ocupation.length" style="width:100%">
                                <v-flex>
                                    <v-text-field :append-icon="index >0 ? 'fa-trash':''" @click:append="deleteocupation(ocupation.id)"
                                    :label="language === 'English'?'occupation '+ parseInt(index+1):'ocupación '+ parseInt(index+1)" v-model="ocupation.name" :rules="[rules.required]" required>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </div>
                    <v-layout >
                        <v-flex > 
                            <v-text-field label="Email" v-model="users.email" :rules="[rules.required, rules.emailvalidate]" required id="email">
                            </v-text-field>
                            <v-layout v-if="emailExist">
                                <label class ="fas fa-exclamation-triangle"> {{language === 'English'?'there is a user with this email': 'Existe un Usuario con este email'}}</label>
                            </v-layout>    
                        </v-flex>
                    </v-layout>
                    <v-layout >
                        <v-flex > 
                            <v-text-field id="userreg" :label="language === 'English'?'Username':'Nombre de usuario'" v-model="users.username" :rules="[rules.required]" required
                            ></v-text-field>
                            <v-layout v-if="userNameExist">
                                <label class ="fas fa-exclamation-triangle"> {{language === 'English' ? 'username is not available': 'El nombre de usuario no esta disponible'}}</label>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                     <!-- CONTRASEÑA -->
                    <v-layout >
                        <v-flex > 
                            <v-text-field 
                                :append-icon="InputPassword ? 'fa-eye-slash' : 'fa-eye'"
                                :rules="[rules.required, rules.min]"
                                :type="InputPassword ? 'text' : 'password'"
                                name="input-10-2"
                                v-model="passwordmodel"
                                :label="language === 'English'?'Password':'Contraseña'"                              
                                value=""
                                class="input-group--focused"
                                @click:append="InputPassword = !InputPassword"
                                required                    
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                     <!-- CONFIRMAR CONTRASEÑA-->
                    <v-layout >
                        <v-flex > 
                            <v-text-field :append-icon="ConfirmPassword ? 'fa-eye-slash' : 'fa-eye'" 
                                :rules="[rules.required, rules.passwordequal]" 
                                :type="ConfirmPassword ? 'text' : 'password'" name="input-10-2" :label="language === 'English'?'Confirm Password':'Confirmar Contraseña'" value="" 
                                class="input-group--focused" @click:append="ConfirmPassword = !ConfirmPassword" required >
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                     <!-- BOTON REGISTRATE -->
                    <v-layout  >
                        <v-flex > 
                            <label>{{language==='English'?'By registering with us you accept our':'Al registrarte con nosotros aceptas nuestros'}}</label>
                            <p><a @click="openmodalpolicyprivacy">{{language==='English'?'Terms of service and privacy policy':'Términos de servicio y politica de privacidad'}}</a></p>
                        </v-flex>
                    </v-layout>      
                    <v-layout justify-center >                        
                        <v-btn :disabled="!valid" v-if="!isloading" type="submit" depressed round color="#b19d9d" style="border:2px solid;border-radius: 10px 10px 10px 10px;width:90%">{{language === 'English'?'SIGN UP':'REGISTRATE'}}</v-btn>  
                        <v-progress-circular
                            v-if="isloading"
                            indeterminate
                            color="primary"
                        ></v-progress-circular> 
                    <!-- TERMINO DE SERVICIO Y POLITICA DE PRIVACIDAD-->
                                  
                    </v-layout> 
                    <v-layout justify-center >                        
                        <v-btn @click="gologinuser" depressed round color="secondary" style="color:white;border:2px solid;border-radius: 10px 10px 10px 10px;width:90%">{{language === 'English'?'Return to Log in':'Volver a Iniciar Sesión'}}</v-btn>                        
                    </v-layout>

                </v-flex>
            </v-layout>
        </v-form>
  </v-container>
</template>

<script>
   import initVue from '../../../../helpers/initVue'
   const alertify = require('alertifyjs')
   import users from '../../../../models/user.js'
//import { EventBus } from '../../../../helpers/eventbus/event-bus';
import {UsersService} from "@/services"
import { EventBus } from '../../../../helpers/eventbus/event-bus'


   export default {
    data () {
      return {
        isloading:false,
        language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
        valid:true,
        InputPassword: false,
        ConfirmPassword: false,
        users:new users(),
        modalregister: false,
        session: false,
        passwordmodel: '',
        userNameExist: false,
        emailExist: false,
        rules: {
          required: value => !!value || `${this.language === 'English'?'Required.':'Requerido.'}`,
          min: v => v.length >= 8 || `${this.language === 'English'? 'Minimum 8 characters': 'Mínimo 8 caracteres'}`,
        //   emailMatch: () => ('The email and password you entered don\'t match'),
            
        //   passwordvalidate: value => {
        //      const pattern = /^(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ]/
        //      return pattern.test(value) || 'Tu contraseña debe tener un carácter, una letra mayúscula, una minúscula y un número'
        //    },
          emailvalidate: value =>{
             const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
             return pattern.test(value) || `${this.language === 'English'? 'the email must contain @ and others characters': 'El email debe contener @ y otros carácteres mas'}`
           },
           passwordequal: value =>{
             let passwordcondition = this.passwordmodel !== value
             return !passwordcondition || `${this.language === 'English'? 'the password does not match the above':  'La contraseña no concuerda con lo anterior escrito'}`
           },
        }
      }
    },
    mounted(){
        this.getidentity()
        this.users.ocupation = [{
            id:1,
            name:''
        }]
        EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        let choosedlanguage = JSON.parse(localStorage.getItem('language'))
        if(choosedlanguage){
            this.language = choosedlanguage.language
        }
     },
    methods: {
        openmodalpolicyprivacy(){
            EventBus.$emit('openmodalpolicyprivacy')
        },
        checkfileproject(idproject){
            this.$router.push('/projects/'+idproject)
        },
        addocupation(){
            if(this.users.ocupation.length < 5){
                this.users.ocupation.push({name:'',id:this.users.ocupation.length +1})
            }else{
                alertify.error(this.language ==='English'?'You can add only 5 occupation, no more':'Puede agregar solo 5 ocupaciones, no más')

            }
        },
        deleteocupation(id){
            let datadelete = this.users.ocupation.filter(data=>data.id != id)
            this.users.ocupation = datadelete
        },
        gologinuser(){
          this.$emit('activeLogin',0)
        },

        /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.identity)
        },
        /*
        goLogin(){
            this.$router.push('/login')
        },*/

        openmodalregister(){
            this.modalregister = true
        },

        
        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        saveIdentity() {
            this.$store.dispatch('saveIdentity', this.identity)
            localStorage.setItem('iden', JSON.stringify(this.identity))
            this.$store.dispatch('saveToken', this.token)
            localStorage.setItem('tok', this.token)
        },

        validate() {
         if (this.$refs.form.validate()) {
            if(this.users.gender === ''){
                alertify.error(this.language === 'English'?'Choose your gender':'Elija su género')
            }else{
            this.snackbar = true
            this.isloading = true
            this.users.password=this.passwordmodel
            //this.users.fullname=this.users.nombres+' '+ this.users.apellidos
            this.users.photo = [{link: '/img/usuario.png', name:''}]
                this.users.visible = true
                UsersService.create(this.users).then(res=>{
                    this.identity = res.data.user
                    this.token = res.data.token
                    setTimeout(() => {
                        this.saveIdentity()
                        let isemailorusernameequal = this.$route.params.nameuser === res.data.username
                        let isindex = this.$route.name ==='Index'
                        if(isindex){                    
                            window.location = `/`
                        }else if(isemailorusernameequal){
                            window.location = `/`
                        }else{
                            window.location = window.location.href
                        }

                    }, 400)
                })
                .catch(err=>{
                    let msg = err.response.data.message
                        this.isloading = false
                        if (msg === "El email ya existe") {
                            this.emailExist = true
                            document.getElementById('email').focus()
                            setTimeout(() => {
                                this.emailExist = false
                            }, 5000)
                        }else if (msg === "El nombre de usuario ya existe") {
                            this.userNameExist = true
                            document.getElementById('userreg').focus()
                            setTimeout(() => {
                                this.userNameExist = false
                            }, 5000)
                        }else {
                            console.log(err)
                        }
                })
            }
           
         }
       },
     },
  }


</script>


